import { printFooterText } from "@/constants";
import styles from "./index.module.scss";

const PrintFooter = () => {
  return (
    <div className={styles.printFooter}>
      <p className="text-[12px]">
        <strong className="text-[15px]">Have Questions?</strong> Visit Us at{" "}
        <a
          href="https://www.kohlerasiapacific.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.kohlerasiapacific.com
        </a>
      </p>
      <p className="text-[12px]">{printFooterText}</p>
    </div>
  );
};

export default PrintFooter;
